import React from 'react';
import { componentWithFG } from '@atlaskit/platform-feature-flags-react';
import { UFOThirdPartySegment } from '@atlaskit/react-ufo/segment';
import { Fragment } from 'react';

const UFOSegmentForgeUnifiedWebRenderer = ({ children }: React.PropsWithChildren) => (
	<UFOThirdPartySegment name="forge-ui-app-content-root">{children}</UFOThirdPartySegment>
);
export const UFOSegmentForgeUnifiedWebRendererRollout: React.FC<
	{
		children?: React.ReactNode | undefined;
	} & {
		children?: React.ReactNode | undefined;
	}
> = componentWithFG(
	'forge-ui-performance-analytics-provider',
	UFOSegmentForgeUnifiedWebRenderer,
	Fragment,
);
